import React, { PureComponent } from 'react';

import { unit } from '@zego/theme';

import VehicleTypeButton from './VehicleTypeButton';

class VehicleChoiceInput extends PureComponent {
  render() {
    const { name, value, choices, onChange } = this.props;

    return (
      <div
        css={{
          width: 'calc(100% + 16px)',
          display: 'flex',
          flexWrap: 'wrap',
          marginLeft: -unit(1),
          marginRight: -unit(1),
        }}
      >
        {choices.map(choice => (
          <div css={{ width: '50%', padding: unit(1) }} key={choice}>
            <VehicleTypeButton
              key={choice}
              name={name}
              value={choice}
              onChange={onChange}
              checked={value === choice}
            />
          </div>
        ))}
      </div>
    );
  }
}

export default VehicleChoiceInput;
